<template>
  <div id="documents" v-if="event">
    <div class="title">
      <h2>{{ $t("volunteers.necessary_documents") }}</h2>
    </div>
    <div class="container">
      <div
        v-if="![15].includes(parseInt(event.type_id))"
        class="row"
        :class="[
          { default: eventInformation.sex_crimes_status == null },
          { to_validate: eventInformation.sex_crimes_status == 1 },
          { validated: eventInformation.sex_crimes_status == 2 },
          { error_document: eventInformation.sex_crimes_status == 3 },
        ]"
      >
        <!-- INSTRUCTIONS -->
        <div data-instructions>
          <div class="instructions">
            <template v-if="eventInformation.sex_crimes_status == null">
              <p class="bold">{{ $t("descriptions.pdf_format") }}</p>
            </template>
            <template v-if="eventInformation.sex_crimes_status == 1">
              <p class="bold">{{ $t("descriptions.mic_validation") }}</p>
            </template>
            <template v-if="eventInformation.sex_crimes_status == 2">
              <p class="bold">{{ $t("descriptions.valit_document") }}</p>
            </template>
            <template
              v-if="
                eventInformation.sex_crimes_status == 3 &&
                !eventInformation.sex_crimes_reject
              "
            >
              <p class="bold">{{ $t("descriptions.invalit_document") }}</p>
            </template>
            <template v-else-if="eventInformation.sex_crimes_status == 3">
              <p class="bold">
                {{
                  $t(
                    rejectDocuments[eventInformation.sex_crimes_reject]
                      ? rejectDocuments[eventInformation.sex_crimes_reject].name
                      : ""
                  )
                }}
              </p>
              <p class="">
                {{
                  $t(
                    rejectDocuments[eventInformation.sex_crimes_reject]
                      ? rejectDocuments[eventInformation.sex_crimes_reject]
                          .description
                      : ""
                  )
                }}
              </p>
            </template>
          </div>
        </div>

        <!-- TITLE -->
        <div class="item description">
          <h5>{{ $t("titles.sex_crimes") }}</h5>
        </div>

        <!-- UPLOAD -->
        <div class="item" v-if="eventInformation.sex_crimes_status != 2">
          <input
            :class="''"
            type="file"
            ref="sex_crimes"
            accept="application/pdf"
            style="display: none"
            @change="upload"
          />
          <button @click="selectDocument('sex_crimes')">
            {{ $t("upload_file") }}
          </button>
        </div>

        <!-- PREVIEW -->
        <div class="item" v-if="eventInformation.sex_crimes_status != null">
          <button
            @click="previewDocument(eventInformation.sex_crimes)"
            class="secondary"
          >
            {{ $t("preview") }}
          </button>
        </div>

        <div class="item">
          <button @click="dialog = true" class="secondary">
            {{ $t("more_information") }}
          </button>
        </div>
      </div>

      <div
        v-if="![5, 12, 13,15].includes(parseInt(event.type_id))"
        class="row"
        :class="[
          { default: eventInformation.volunteer_agreement_status == null },
          { to_validate: eventInformation.volunteer_agreement_status == 1 },
          { validated: eventInformation.volunteer_agreement_status == 2 },
          { error_document: eventInformation.volunteer_agreement_status == 3 },
        ]"
      >
        <div>
          <div class="instructions">
            <template
              v-if="eventInformation.volunteer_agreement_status == null"
            >
              <p class="bold">{{ $t("descriptions.pdf_format") }}</p>
            </template>
            <template v-if="eventInformation.volunteer_agreement_status == 1">
              <p class="bold">{{ $t("descriptions.mic_validation") }}</p>
            </template>
            <template v-if="eventInformation.volunteer_agreement_status == 2">
              <p class="bold">{{ $t("descriptions.valit_document") }}</p>
            </template>
            <template
              v-if="
                eventInformation.volunteer_agreement_status == 3 &&
                !eventInformation.volunteer_agreement_reject
              "
            >
              <p class="bold">{{ $t("descriptions.invalit_document") }}</p>
            </template>
            <template v-else-if="eventInformation.volunteer_agreement_status == 3">
              <p class="bold">
                {{
                  $t(
                    rejectDocuments[eventInformation.volunteer_agreement_reject]
                      ? rejectDocuments[
                          eventInformation.volunteer_agreement_reject
                        ].name
                      : ""
                  )
                }}
              </p>
              <p class="">
                {{
                  $t(
                    rejectDocuments[eventInformation.volunteer_agreement_reject]
                      ? rejectDocuments[
                          eventInformation.volunteer_agreement_reject
                        ].description
                      : ""
                  )
                }}
              </p>
            </template>
          </div>
        </div>

        <!-- TITLE -->
        <div class="item description">
          <h5>{{ $t("titles.volunteer_agreement") }}</h5>
        </div>

        <!-- DOWNLOAD -->
        <div
          class="item"
          v-if="eventInformation.volunteer_agreement_status != 2"
        >
          <button @click="downloadVolunteerAgreement" class="secondary">
            {{ $t("download") }}
          </button>
        </div>

        <!-- UPLOAD -->
        <div
          class="item"
          v-if="eventInformation.volunteer_agreement_status != 2"
        >
          <input
            :class="''"
            type="file"
            ref="volunteer_agreement"
            accept="application/pdf"
            style="display: none"
            @change="upload"
          />
          <button @click="selectDocument('volunteer_agreement')">
            {{ $t("upload_file") }}
          </button>
        </div>

        <!-- PREVIEW -->
        <div
          class="item"
          v-if="eventInformation.volunteer_agreement_status != null"
        >
          <button
            @click="previewDocument(eventInformation.volunteer_agreement)"
            class="secondary"
          >
            {{ $t("preview") }}
          </button>
        </div>
      </div>

      <div
        v-if="[15].includes(parseInt(event.type_id))"
        class="row"
        :class="[
          { default: eventInformation.volunteer_agreement_status == null },
          { to_validate: eventInformation.volunteer_agreement_status == 1 },
          { validated: eventInformation.volunteer_agreement_status == 2 },
          { error_document: eventInformation.volunteer_agreement_status == 3 },
        ]"
      >
        <div>
          <div class="instructions">
            <template
              v-if="eventInformation.volunteer_agreement_status == null"
            >
              <p class="bold">{{ $t("descriptions.pdf_format") }}</p>
            </template>
            <template v-if="eventInformation.volunteer_agreement_status == 1">
              <p class="bold">{{ $t("descriptions.mic_validation") }}</p>
            </template>
            <template v-if="eventInformation.volunteer_agreement_status == 2">
              <p class="bold">{{ $t("descriptions.valit_document") }}</p>
            </template>
            <template
              v-if="
                eventInformation.volunteer_agreement_status == 3 &&
                !eventInformation.volunteer_agreement_reject
              "
            >
              <p class="bold">{{ $t("descriptions.invalit_document") }}</p>
            </template>
            <template v-else-if="eventInformation.volunteer_agreement_status == 3">
              <p class="bold">
                {{
                  $t(
                    rejectDocuments[eventInformation.volunteer_agreement_reject]
                      ? rejectDocuments[
                          eventInformation.volunteer_agreement_reject
                        ].name
                      : ""
                  )
                }}
              </p>
              <p class="">
                {{
                  $t(
                    rejectDocuments[eventInformation.volunteer_agreement_reject]
                      ? rejectDocuments[
                          eventInformation.volunteer_agreement_reject
                        ].description
                      : ""
                  )
                }}
              </p>
            </template>
          </div>
        </div>

        <!-- TITLE -->
        <div class="item description">
          <h5>{{ $t("titles.volunteer_agreement_puntacana") }}</h5>
        </div>

        <!-- DOWNLOAD -->
        <div
          class="item"
          v-if="eventInformation.volunteer_agreement_status != 2"
        >
          <button @click="downloadVolunteerAgreement" class="secondary">
            {{ $t("download") }}
          </button>
        </div>

        <!-- UPLOAD -->
        <div
          class="item"
          v-if="eventInformation.volunteer_agreement_status != 2"
        >
          <input
            :class="''"
            type="file"
            ref="volunteer_agreement"
            accept="application/pdf"
            style="display: none"
            @change="upload"
          />
          <button @click="selectDocument('volunteer_agreement')">
            {{ $t("upload_file") }}
          </button>
        </div>

        <!-- PREVIEW -->
        <div
          class="item"
          v-if="eventInformation.volunteer_agreement_status != null"
        >
          <button
            @click="previewDocument(eventInformation.volunteer_agreement)"
            class="secondary"
          >
            {{ $t("preview") }}
          </button>
        </div>
      </div>

      <div
        v-if="[5, 12, 13].includes(parseInt(event.type_id))"
        class="row"
        :class="[
          { default: eventInformation.volunteer_titularity_status == null },
          { to_validate: eventInformation.volunteer_titularity_status == 1 },
          { validated: eventInformation.volunteer_titularity_status == 2 },
          { error_document: eventInformation.volunteer_titularity_status == 3 },
        ]"
      >
        <div>
          <div class="instructions">
            <template
              v-if="eventInformation.volunteer_titularity_status == null"
            >
              <p class="bold">{{ $t("descriptions.pdf_format") }}</p>
            </template>
            <template v-if="eventInformation.volunteer_titularity_status == 1">
              <p class="bold">{{ $t("descriptions.mic_validation") }}</p>
            </template>
            <template v-if="eventInformation.volunteer_titularity_status == 2">
              <p class="bold">{{ $t("descriptions.valit_document") }}</p>
            </template>
            <template
              v-if="
                eventInformation.volunteer_titularity_status == 3 &&
                !eventInformation.volunteer_titularity_reject
              "
            >
              <p class="bold">{{ $t("descriptions.invalit_document") }}</p>
            </template>
            <template
              v-else-if="eventInformation.volunteer_titularity_status == 3"
            >
              <p class="bold">
                {{
                  $t(
                    rejectDocuments[
                      eventInformation.volunteer_titularity_reject
                    ]
                      ? rejectDocuments[
                          eventInformation.volunteer_titularity_reject
                        ].name
                      : ""
                  )
                }}
              </p>
              <p class="">
                {{
                  $t(
                    rejectDocuments[
                      eventInformation.volunteer_titularity_reject
                    ]
                      ? rejectDocuments[
                          eventInformation.volunteer_titularity_reject
                        ].description
                      : ""
                  )
                }}
              </p>
            </template>
          </div>
        </div>

        <!-- TITLE -->
        <div class="item description">
          <h5>{{ $t("titles.volunteer_titularity") }}</h5>
        </div>

        <!-- UPLOAD -->
        <div
          class="item"
          v-if="eventInformation.volunteer_titularity_status != 2"
        >
          <input
            :class="''"
            type="file"
            ref="volunteer_titularity"
            accept="application/pdf"
            style="display: none"
            @change="upload"
          />
          <button @click="selectDocument('volunteer_titularity')">
            {{ $t("upload_file") }}
          </button>
        </div>

        <!-- PREVIEW -->
        <div
          class="item"
          v-if="eventInformation.volunteer_titularity_status != null"
        >
          <button
            @click="previewDocument(eventInformation.volunteer_titularity)"
            class="secondary"
          >
            {{ $t("preview") }}
          </button>
        </div>
      </div>

      <div
        v-if="[1].includes(parseInt(event.type_id))"
        class="row default"
      >

        <!-- TITLE -->
        <div class="item description">
          <h5>{{ $t("titles.volunteer_protocol_sexual_violence") }}</h5>
        </div>

        <!-- DOWNLOAD -->
        <div
          class="item"
          v-if="eventInformation.volunteer_agreement_status != 2"
        >
          <button @click="downloadVolunteerProtocolSexualViolence" class="secondary">
            {{ $t("download") }}
          </button>
        </div>
      </div>

      <div
        v-if="[1].includes(parseInt(event.type_id))"
        class="row default"
      >

        <!-- TITLE -->
        <div class="item description">
          <h5>{{ $t("titles.volunteer_protocol_children") }}</h5>
        </div>

        <!-- DOWNLOAD -->
        <div
          class="item"
        >
          <button @click="downloadVolunteerProtocolChildren" class="secondary">
            {{ $t("download") }}
          </button>
        </div>
      </div>

      <div
        v-if="[1].includes(parseInt(event.type_id))"
        class="row default"
      >

        <!-- TITLE -->
        <div class="item description">
          <h5>{{ $t("titles.volunteer_functions") }}</h5>
        </div>

        <!-- DOWNLOAD -->
        <div
          class="item"
        >
          <button @click="downloadVolunteerFunctions" class="secondary">
            {{ $t("download") }}
          </button>
        </div>
      </div>

      <div
        v-if="[1].includes(parseInt(event.type_id))"
        class="row default"
      >
        <div class="item description">
          <h5>{{ $t("volunteers.documents.individual_commitment") }}</h5>
        </div>
        <div class="item">
          <button
            v-if="parseInt(eventInformation.legal_individual_status, 10) === 1"
            type="button"
            class="individual-commitment-signed"
            disabled
          >
            {{ $t("volunteers.signed") }}
          </button>
          <button
            v-else
            type="button"
            class="secondary"
            @click="$router.push({ name: 'sign_individual_commitment', params: { event_id: $route.params.event_id } })"
          >
            {{ $t("volunteers.sign") }}
          </button>
        </div>
      </div>

      <v-dialog
        v-model="dialog"
        width="600"
        class="modal"
        :hide-overlay="true"
        data-app
      >
        <div id="popup1" style="padding-bottom: 0">
          <div class="header">
            <img
              v-on:click="closeDialog()"
              v-bind:src="'/img/error.svg'"
              alt="delete"
            />
          </div>
          <div class="main">
            <p v-html="$t('volunteer_sex_crimes.header')"></p>
            <!-- <p>{{ $t("volunteer_sex_crimes.p1") }}</p>
            <p>{{ $t("volunteer_sex_crimes.p2") }}</p>
            <p>{{ $t("volunteer_sex_crimes.p3") }}</p>
            <p>{{ $t("volunteer_sex_crimes.p4") }}</p>
            <p>{{ $t("volunteer_sex_crimes.p5") }}</p>
            <p>{{ $t("volunteer_sex_crimes.p6") }}</p> -->
          </div>
        </div>
      </v-dialog>
    </div>
  </div>
</template>

<script>
/* global moment */
export default {
  name: 'Documents',
  data () {
    return {
      files: {
        sex_crimes: '',
        volunteer_agreement: '',
        volunteer_titularity: ''
      },

      error: {
        sex_crimes: {
          format_document: false,
          upload: false
        },
        volunteer_agreement: {
          format_document: false,
          upload: false
        },
        volunteer_titularity: {
          format_document: false,
          upload: false
        }
      },

      dialog: false
    }
  },
  computed: {
    user () {
      return this.$store.getters['getUser']
    },

    eventInformation () {
      return this.$store.getters['getEventInformation']
    },

    rejectDocuments () {
      return this.$store.getters['getRejectDocuments']()
    },

    event () {
      return this.$store.getters['events/getList'](this.$route.params.event_id)
    }
  },
  created () {
    this.load()
  },
  methods: {
    load () {
      this.$store.dispatch('getRelVolunteerEvent', {
        person_id: this.user.person_id,
        event_id: this.$route.params.event_id
      })
    },

    upload () {
      var self = this
      var files = []

      Object.entries(this.files).forEach(([key]) => {
        if (
          self.$refs[key] &&
          typeof self.$refs[key].files[0] !== 'undefined'
        ) {
          if (self.$refs[key].files[0].type === 'application/pdf') {
            files[key] = self.$refs[key].files[0]
          }
        }
      })

      this.$store
        .dispatch('upload', {
          files: files,
          id: this.user.person_id,
          event_id: this.$route.params.event_id
        })
        .then(function (response) {
          if (response.status) {
            if (response.data.sex_crimes) {
              self.$store
                .dispatch('updateDocuments', {
                  person_id: self.user.person_id,
                  event_id: self.$route.params.event_id,
                  document_type: 'sex_crimes',
                  document: response.data.sex_crimes,
                  status: 1
                })
                .then(function (response) {
                  self.load()
                })
            } else if (response.data.volunteer_agreement) {
              self.$store
                .dispatch('updateDocuments', {
                  person_id: self.user.person_id,
                  event_id: self.$route.params.event_id,
                  document_type: 'volunteer_agreement',
                  document: response.data.volunteer_agreement,
                  status: 1
                })
                .then(function (response) {
                  self.load()
                })
            } else if (response.data.volunteer_titularity) {
              self.$store
                .dispatch('updateDocuments', {
                  person_id: self.user.person_id,
                  event_id: self.$route.params.event_id,
                  document_type: 'volunteer_titularity',
                  document: response.data.volunteer_titularity,
                  status: 1
                })
                .then(function (response) {
                  self.load()
                })
            }
          }
        })
    },

    selectDocument (document) {
      this.$refs[document].value = ''
      this.$refs[document].click()
    },

    previewDocument (document) {
      window.open(document + '?' + moment().valueOf(), '_blank')
    },

    downloadVolunteerAgreement (document) {
      let event = this.user.events[this.$route.params.event_id].name
      let route =
        process.env.VUE_APP_APP_URL +
        'convenis/' +
        event.replace(/ /g, '').toLowerCase() +
        '.pdf?' +
        moment().valueOf()
      window.open(route)
    },

    downloadVolunteerProtocolSexualViolence (document) {
      let event = this.user.events[this.$route.params.event_id].name
      let language = this.user.language ? this.user.language : 'es';
      let route =
        process.env.VUE_APP_APP_URL +
        'protocolos/' +
        event.replace(/ /g, '').toLowerCase() +
        '/protocolo-sexual-violencia_'+language+'.pdf?' +
        moment().valueOf()
      window.open(route)
    },

    downloadVolunteerProtocolChildren (document) {
        let language = this.user.language ? this.user.language : 'es';
      let event = this.user.events[this.$route.params.event_id].name
      let route =
        process.env.VUE_APP_APP_URL +
        'protocolos/' +
        event.replace(/ /g, '').toLowerCase() +
        '/protocolo-proteccion-infancia-adolescencia_'+language+'.pdf?' +
        moment().valueOf()
      window.open(route)
    },

    downloadVolunteerFunctions (document) {
        let language = this.user.language ? this.user.language : 'es';
      let event = this.user.events[this.$route.params.event_id].name
      let route =
        process.env.VUE_APP_APP_URL +
        'protocolos/' +
        event.replace(/ /g, '').toLowerCase() +
        '/funciones-responsabilidades-voluntarios_'+language+'.pdf?' +
        moment().valueOf()
      window.open(route)
    },

    closeDialog () {
      this.dialog = false
    }
  },

  watch: {
    $route: 'load'
  }
}
</script>

<style lang="scss" scoped>
#documents {
  h5,
  .download {
    display: inline-block;
  }
  .download {
    cursor: pointer;
    font-weight: bold;
    text-decoration: underline;
  }
  .container {
    padding: 0;
    margin-top: 20px;
    .row {
      width: 100%;
      padding: 10px;
      margin-bottom: 20px;
      .item {
        width: 150px;
        display: inline-block;
        height: 100% !important;
        margin: 0 auto;
        vertical-align: middle;
        text-align: center;

        button {
          width: 125px !important;
          padding: 0;
          margin: 0;
          height: 100%;
          min-width: 40px;
          outline: none;
          cursor: pointer;
          font-size: 8pt;
          font-family: Speedee-Bold;
          // margin-top: 5px;
          border-radius: 3px;
          border: 1px solid #fc8926;
          text-transform: uppercase;
          background-color: transparent;
          color: #fff;
          height: 40px;
          padding: 0;
          font-family: Roboto-Bold;
          font-size: 14px;
          line-height: 14px;
          transition: background-color 0.5s ease;
          vertical-align: middle;
          margin: 0 auto;
          background-color: #fc8926;

          &:hover {
            background-color: #e78026;
            border-color: #e78026;
          }
        }

        .secondary {
          background-color: white;
          color: #c55c00;
          border: 2px solid #fc8926;
          transition: 0.25s ease;
          &:hover {
            background-color: #fc8a2623 !important;
            color: white;
          }
        }
      }
      .description {
        width: auto;
      }
      div {
        .bold {
          font-weight: bold;
        }
      }
    }
    .instructions {
      span {
        display: block;
      }
    }
  }

  .default {
    border: 2px solid grey;
    background-color: rgb(240, 240, 240);
  }

  .to_validate {
    border: 2px solid yellow;
    background-color: rgb(252, 255, 225);
  }

  .validated {
    border: 2px solid green;
    background-color: rgb(220, 255, 220);
  }

  .error_document {
    border: 2px solid red;
    background-color: rgb(255, 212, 212);
  }

  .individual-commitment-signed {
    background-color: #e8f5e9 !important;
    color: #1b5e20 !important;
    border: 2px solid #a5d6a7 !important;
    cursor: default !important;
    opacity: 1 !important;

    &:hover {
      background-color: #e8f5e9 !important;
      border-color: #a5d6a7 !important;
      color: #1b5e20 !important;
    }
  }
}

@include media("<desktop") {
  #documents {
    .container {
      .row {
        .item {
          margin: 5px 0;
          width: 100%;
          button {
            width: 80% !important;
          }
        }
      }
    }
  }
}
</style>
